import { useTranslation } from "react-i18next";

interface ITypeCourse {
	type: string;
}

/** Componente que traduz uma string de tipo de curso para o idioma da página */
export const TypeCourse: React.FC<ITypeCourse> = (props) => {
	const { t: translate } = useTranslation();

	const handleNameModality = (_modality: string) => {
		switch (_modality.toLowerCase()) {
			case "free":
				return translate("manager.modality.free");
			case "1":
			case "graduate":
				return translate("manager.modality.graduate");
			case "2":
			case "postgraduate":
				return translate("manager.modality.postgraduate");
			default:
				return _modality;
		}
	};

	return <span>{handleNameModality(props.type)}</span>;
};
